// Läuft vor den Polyfills (siehe runHostGuard.js): nur Syntax/APIs verwenden, die
// jede unterstützte Engine ohne core-js kennt. Dieses Modul darf den Klartext der
// eigenen Domain nicht enthalten, damit ein Such-und-Ersetzen im Bundle es nicht
// aushebelt — die Hosts werden nur als FNV-1a-Hash geführt, die Redirect-Domain
// wird zur Laufzeit zusammengesetzt (ClickUp 869fjuh69).

// FNV-1a 32 bit über den kleingeschriebenen Hostnamen.
const OWN_HOST_HASHES = [2971440039, 4188706868, 2938398565, 2258227510, 464575906];
const LOCAL_HOSTS = ['localhost', '127.0.0.1'];
const TRANSLATE_SUFFIX = '.translate.goog';
// Google Translate kodiert den Host als Präfix (Punkt → "-"); nur die eigenen Hosts sind erlaubt,
// sonst käme eine über Translate geproxte Fremdkopie durch.
const OWN_TRANSLATE_PREFIX_HASHES = [1553111186, 3873018460];
// Char-Codes der Redirect-Domain.
const OWN_DOMAIN_CODES = [118, 97, 110, 115, 105, 116, 101, 46, 101, 117];

export const hashHost = (host) => {
  let hash = 0x811c9dc5;
  for (let i = 0; i < host.length; i += 1) {
    hash ^= host.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash >>> 0;
};

const isOwnTranslateHost = (host) => {
  const start = host.length - TRANSLATE_SUFFIX.length;
  if (start <= 0 || host.indexOf(TRANSLATE_SUFFIX, start) !== start) {
    return false;
  }
  return OWN_TRANSLATE_PREFIX_HASHES.indexOf(hashHost(host.slice(0, start))) !== -1;
};

const isKnownHost = (host) =>
  OWN_HOST_HASHES.indexOf(hashHost(host)) !== -1 ||
  LOCAL_HOSTS.indexOf(host) !== -1 ||
  isOwnTranslateHost(host);

// Bewusst kein `window.cordova`-Check: den könnte ein eingeschleustes Skript setzen. Die App läuft
// unter einem eigenen Host, `localhost` oder einem Nicht-HTTP-Schema (file:, app:).
const isWebProtocol = () => {
  const { protocol } = window.location;
  return protocol === 'http:' || protocol === 'https:';
};

/**
 * Whether the app is served from one of our own hosts (or an allowed context).
 * Always true on the server (SSR) and for non-HTTP schemes (Cordova).
 *
 * @param {string} [hostname] - Defaults to window.location.hostname.
 * @returns {boolean}
 */
export const isOwnHost = (hostname) => {
  if (typeof window === 'undefined' || !isWebProtocol()) {
    return true;
  }
  const host = String(hostname === undefined ? window.location.hostname : hostname).toLowerCase();
  return isKnownHost(host);
};

const ownDomain = () => String.fromCharCode.apply(null, OWN_DOMAIN_CODES);

/**
 * Sends the visitor to the real site and aborts bundle evaluation when the app is
 * served from a foreign host (e.g. a reverse proxy mirroring our pages).
 */
export const enforceOwnHost = () => {
  if (isOwnHost()) {
    return;
  }
  const { pathname, search, hash } = window.location;
  window.location.replace(`https://${ownDomain()}${pathname}${search}${hash}`);
  throw new Error('foreign-host');
};
